module.exports = __webpack_public_path__ + "static/media/schedule_structure_change_lunch_name.c6813eb7.mov";